var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"uk-tooltip":_vm.tooltip ? 'title:' + _vm.tooltip : ''}},[_c('div',{class:'cursor-initial uk-label uk-label-' + _vm.mode + _vm.generateClasses()},[_c('div',{staticClass:"uk-flex uk-flex-middle"},[(_vm.icon)?_c('Icon',{staticClass:"icon",attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" "),_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }